"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The SlideCommentFilter model module.
 * @module model/SlideCommentFilter
 * @version 1.1.3-alpha.1
 */
class SlideCommentFilter {
  /**
   * Constructs a new <code>SlideCommentFilter</code>.
   * @alias module:model/SlideCommentFilter
   */
  constructor() {
    SlideCommentFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>SlideCommentFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SlideCommentFilter} obj Optional instance to populate.
   * @return {module:model/SlideCommentFilter} The populated <code>SlideCommentFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SlideCommentFilter();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('slide_id')) {
        obj['slide_id'] = _ApiClient.default.convertToType(data['slide_id'], 'String');
      }
      if (data.hasOwnProperty('parent_id')) {
        obj['parent_id'] = _ApiClient.default.convertToType(data['parent_id'], 'String');
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>SlideCommentFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SlideCommentFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['slide_id'] && !(typeof data['slide_id'] === 'string' || data['slide_id'] instanceof String)) {
      throw new Error("Expected the field `slide_id` to be a primitive type in the JSON string but got " + data['slide_id']);
    }
    // ensure the json data is a string
    if (data['parent_id'] && !(typeof data['parent_id'] === 'string' || data['parent_id'] instanceof String)) {
      throw new Error("Expected the field `parent_id` to be a primitive type in the JSON string but got " + data['parent_id']);
    }
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
SlideCommentFilter.prototype['id'] = undefined;

/**
 * @member {String} slide_id
 */
SlideCommentFilter.prototype['slide_id'] = undefined;

/**
 * @member {String} parent_id
 */
SlideCommentFilter.prototype['parent_id'] = undefined;

/**
 * @member {String} q
 */
SlideCommentFilter.prototype['q'] = undefined;
var _default = exports.default = SlideCommentFilter;